import { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { NoMobile } from '../pages/NoMobile';
import { useIsMobileDevice } from 'utils';

type Props = {
	layout: ComponentType<any>;
	component: ComponentType<any>;
	state: any;
	isAuthenticated: boolean;
	isMobileRoute?: boolean;
};

export const PrivateRoute = ({
	layout: Layout,
	component: Component,
	isAuthenticated,
	state: State,
	isMobileRoute = false
}: Props) => {
	const isMobileDevice = useIsMobileDevice();

	if (!isAuthenticated) {
		return (
			<Navigate
				to={'/login'}
				replace
			/>
		);
	}

	if (!isMobileRoute && isMobileDevice) {
		return (
			<Layout>
				<NoMobile />
			</Layout>
		);
	}

	return (
		<Layout>
			<Component location={{ state: State }}></Component>
		</Layout>
	);
};
